export default function PageHero({data}) {
    return (
        <section className="consultancy-hero-strip">
        <div className="consultancy-hero-overlay-dark" />
        <div className="container position-relative z-index-3 text-center" data-aos="fade-up">
          <span className="premium-kicker-node">{data.kicker}</span>
          <h1 className="hero-primary-statement">{data.title}</h1>
          <p className="hero-supporting-paragraph mx-auto">{data.description}</p>
        </div>
      </section>
    )
}